/* eslint-disable react/no-unescaped-entities */
import { TextInput } from 'nhsuk-react-components';
import React, { ChangeEvent } from 'react';

interface IterationNameProps {
    value?: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    error?: string;
}

// eslint-disable-next-line react/function-component-definition
const IterationName: React.FC<IterationNameProps> = ({
  value = '',
  onChange,
  error,
}) => {
  const inputValue = value || '';

  return (
    <div>
      <h4>Iteration name</h4>
      <p>
        Choose a name that describes the iteration and is easy to
        understand. For example, 'Reminder 65+ in London and 75+
        elsewhere'.
      </p>
      <TextInput
        id="iteration-name"
        aria-label="iteration-name"
        data-testid="iteration-name"
        name="Name"
        label="The name of the iteration must be unique and not duplicated."
        onChange={onChange}
        value={inputValue}
        error={error}
      />
    </div>
  );
};

export default IterationName;
